import {
    FETCH_MATCH_DATA,
    CREATE_LIVE_FOR_MATCH, 
    CANCEL_LIVE, SUBSCRIBE, 
    UPDATE_LIVE_ON_MATCH_DATA, 
    DELETE_LIVE_ON_MATCH_DATA, 
    WORKER_CANCEL_LIVE_ON_MATCH_DATA,
    UNSUBSCRIBE_LIVE,
    END_LIVE
} from '../constants';
import _ from 'lodash';
import { me, extract } from '../helpers';
import moment from 'moment';

export default (state = {upcoming: {}, past: {}}, action) => {
    const caches = localStorage.getItem('matchData') ? JSON.parse(localStorage.getItem('matchData')) : {}
    const cache_ttl = caches.cache_ttl_expires_at ? caches.cache_ttl_expires_at : moment().add(1, 'week').unix();
    switch(action.type) {
        case FETCH_MATCH_DATA: return action.payload;
        case CREATE_LIVE_FOR_MATCH:
            const newlyLive = _.assign(action.payload.live, {author: {id: me().id, firstname: me().firstname, lastname: me().lastname, nickname: me().nickname} });
            const newlyData = _.values(_.mapValues(state.upcoming, v => v.maNo === action.payload.maNo ? _.assignIn(_.find(state.upcoming, {maNo: action.payload.maNo}), {lives: [...v.lives,newlyLive]}) : v));
            const assign = _.assign(state, {upcoming: newlyData, cache_ttl_expires_at: cache_ttl});
            localStorage.setItem('matchData', JSON.stringify(assign));
            return {...state};
        case CANCEL_LIVE: 
            const match = _.find(state.upcoming, {maNo: action.payload.maNo});
            if(match && !_.isEmpty(match)) {
                _.remove(match.lives, l => l.id === action.payload.live || extract(l['@id'], '/', 3) === action.payload.live);
            }
            localStorage.setItem('matchData', JSON.stringify(state));
            return {...state};
        case SUBSCRIBE:
            const findMatch = _.find(state.upcoming, m => !_.isEmpty(_.find(m.lives, l => l.id === action.payload.live || l['@id'] === `/api/lives/${action.payload.live}`)));
            if(findMatch && !_.isEmpty(findMatch)) {
                const findLive = _.find(findMatch.lives, l => l.id === action.payload.live || l['@id'] === `/api/lives/${action.payload.live}`);
                if(findLive && !_.isEmpty(findLive)) {
                    _.assignIn(findLive, {subscribers: [{'@id': `/api/users/${me().id}`, firstname: me().firstname, lastname: me().lastname, nickname: me().nickname}]} );
                }
                localStorage.setItem('matchData', JSON.stringify(state));
            }
            return {...state};
        case UPDATE_LIVE_ON_MATCH_DATA:
            const matchData = _.find(state.upcoming, m => !_.isEmpty(_.find(m.lives, l => l['@id'] === `/api/lives/${action.payload.id}` || l.id === parseInt(action.payload.id) )));
            if(matchData && !_.isEmpty(matchData)) {
                const liveData = _.find(matchData.lives, l => l['@id'] === `/api/lives/${action.payload.id}` || l.id === parseInt(action.payload.id));
                if(liveData && !_.isEmpty(liveData)) {
                    _.assignIn(liveData, {actions: [action.payload.actions]});
                }
                localStorage.setItem('matchData', JSON.stringify(state));
            }
            return {...state};
        case DELETE_LIVE_ON_MATCH_DATA:
            const findMatchData = _.find(state.upcoming, m => !_.isEmpty(_.find(m.lives, l => l['@id'] === `/api/lives/${action.payload.id}` || l.id === parseInt(action.payload.id) )));
            if(findMatchData && !_.isEmpty(findMatchData)) {
                const findLiveData = _.find(findMatchData.lives, l => l['@id'] === `/api/lives/${action.payload.id}` || l.id === parseInt(action.payload.id));
                if(findLiveData && !_.isEmpty(findLiveData)) {
                    _.remove(findLiveData.actions, v => _.find(v, a => a['@id'] === action.payload.action || a === action.payload.action));
                }
                localStorage.setItem('matchData', JSON.stringify(state));
            }
            return {...state};
        case WORKER_CANCEL_LIVE_ON_MATCH_DATA:
                const localMatch = _.find(state.upcoming, m => !_.isEmpty(_.find(m.lives, l => l['@id'] === `/api/lives/${action.payload.id}` || l.id === parseInt(action.payload.id) )));
                if(localMatch && !_.isEmpty(localMatch)) {
                    _.remove(localMatch.lives, l => l['@id'] === `/api/lives/${action.payload.id}` || l.id === parseInt(action.payload.id));
                }
                localStorage.setItem('matchData', JSON.stringify(state));
                return {...state};
        case UNSUBSCRIBE_LIVE:
            let oneMatch = _.find(state.upcoming, m => !_.isEmpty(_.find(m.lives, l => l.id === action.payload.id || l['@id'] === `/api/lives/${action.payload.id}`)));
            if(oneMatch && !_.isEmpty(oneMatch)) {
                let oneLive = _.find(oneMatch.lives, l => l.id === action.payload.id || l['@id'] === `/api/lives/${action.payload.id}`);
                if(oneLive && !_.isEmpty(oneLive)) {
                    _.remove(oneLive.subscribers, s => s['@id'] === s.unsubscriber || s.id === extract(s.unsubscriber, '/', 3));
                }
                localStorage.setItem('matchData', JSON.stringify(state));
            }
            return {...state};
        case END_LIVE:
            const currentMatchData = _.find(state.upcoming, m => !_.isEmpty(_.find(m.lives, l => l['@id'] === `/api/lives/${action.payload.id}` || l.id === parseInt(action.payload.id) )));
            if(currentMatchData && !_.isEmpty(currentMatchData)) {
                const currentLiveData = _.find(currentMatchData.lives, l => l['@id'] === `/api/lives/${action.payload.id}` || l.id === parseInt(action.payload.id));
                if(currentLiveData && !_.isEmpty(currentLiveData)) {
                    _.set(currentLiveData, 'ended', true);
                }
                localStorage.setItem('matchData', JSON.stringify({...state}));
            }
            return {...state}
        default: return state;
    }
}